if($('.type-detail').length){
    $('.p-info-wrapper').append('<span data-url="'+vernostniProgram+'" class="customColorbox"><img src="'+vernostniProgramImage+'"></span>')
    $('.social-buttons-wrapper').before('<div class="productsCare"><span class="customColorbox" data-url="'+productCareUrl+'">'+productCare+'</span></div>')
    $(document).on('click', '.customColorbox', function(){
        $.ajax({
            url: $(this).attr('data-url'),
            success: function(data) {
                var content = $(data).find('.content-inner').html();
                $('body').addClass('colorboxOpen')
                $.colorbox({
                    html: content,
                    width: 700,
                    maxWidth: "95%",
                    height: 600,
                    maxHeight: "95%",
                    className: "",
                    onComplete: function() {
                        $('body').addClass('colorboxOpen')
                    },
                    onClosed: function(){
                        $('body').removeClass('colorboxOpen')
                    }
                });
            },
            error: function() {
                alert('Obsah se nepodařilo načíst.');
            }
        });
    })
}